<script>
    import * as animateScroll from "svelte-scrollto";
    import {onMount} from 'svelte';
    import Icon from 'fa-svelte';
    import {faSortUp} from '@fortawesome/free-solid-svg-icons/faSortUp';
    import {faSortDown} from '@fortawesome/free-solid-svg-icons/faSortDown';
    import CVSTable from '../table.svelte';

    export let handleClickPost;
    export let subSelection;

    let posts;
    let pagination;

    const proxyurl = "";
    const urlCvs = 'https://plataforma.cvschile.cl/site/news';

    onMount(async () => {

        let page = '';

        if (window.location.hash.split('/').length === 3) {
            page = '?page=' + window.location.hash.split('/')[2];
        }

        try {
            const response = await fetch(proxyurl + urlCvs + page)
            let json = await response.json();
            posts = json['news'];
            pagination = json['pagination'];
        } catch (error) {
            console.log(error);
        }

        posts.forEach(element => {

            let unix_timestamp = element.published_at;

            var date = new Date(unix_timestamp * 1000);

            element.published_at = date.toLocaleString();

        });

        if (subSelection == 0) animateScroll.scrollToTop();
        else animateScroll.scrollTo({element: '#about-section-' + subSelection, offset: -80});

    });

    let handleClickPostNav = async (url) => {
        if (subSelection == 0) animateScroll.scrollToTop();
        else animateScroll.scrollTo({element: '#about-section-' + subSelection, offset: -80});

        posts = null;
        pagination = null;

        let selectedPage = url.split('=')[1];

        window.location.hash = "#/news/" + selectedPage;

        let page = '?page=' + selectedPage;

        try {
            const response = await fetch(proxyurl + urlCvs + page)
            let json = await response.json();
            posts = json['news'];
            pagination = json['pagination'];
        } catch (error) {
            console.log(error);
        }

        posts.forEach(element => {

            let unix_timestamp = element.published_at;

            var date = new Date(unix_timestamp * 1000);

            element.published_at = date.toLocaleString();

        });

        if (subSelection == 0) animateScroll.scrollToTop();
        else animateScroll.scrollTo({element: '#about-section-' + subSelection, offset: -80});
    }

    let onlyText = (text) => {
        return text.replace(/<[^>]*>/g, "");
    }
</script>

<div class="row">

    <div class="col-12 white-bg" style="overflow:hidden;min-height: 100vh;">
        <img src="./img/background-A.svg" alt="" class="background-right disabe-img" style="height: 100vh;">
        <div class="row">
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                {#if posts}
                    {#each posts as post, i}
                        <div class="text-content">
                            <div class="row">
                                <div class="card flex-md-row mb-4 box-shadow h-md-250">
                                    <div class="card-body d-flex flex-column align-items-start">
                                        <h3 class="mb-0">
                                            <span class="text-dark pseudo-link" on:click={handleClickPost(post)}>{post.title}</span>
                                        </h3>
                                        <!-- <div class="mb-1 text-muted">{post.published_at}</div> -->
                                        <br>
                                        <p class="card-text mb-auto giveMeEllipsis">
                                            {onlyText(post.body)}
                                        </p>
                                        <span class="pseudo-link" on:click={handleClickPost(post)}>Continuar leyendo</span>
                                    </div>
                                    {#if post.thumbnail_base_url != null}
                                        <img class="card-img-right flex-auto d-none d-md-block" alt="Thumbnail"
                                             src="{post.thumbnail_base_url + '/' + post.thumbnail_path}" width="200"
                                             height="250"
                                             style="max-width: 200px; max-height: 400px; width: 100%; height: 100%;">
                                    {/if}
                                </div>
                            </div>
                        </div>
                    {/each}
                {:else}
                    <div class="d-flex justify-content-center" style="margin-top:25%">
                        <div class="spinner-border" role="status" style="height: 100px;width: 100px;">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                {/if}
            </div>
        </div>
        {#if pagination}
            <div class="row justify-content-between">
                <div class="col-4 text-right">
                    {#if typeof pagination['prev'] != "undefined"}
                        <button class="post-button-nav" on:click={handleClickPostNav(pagination['prev'])}>Anterior
                        </button>
                    {/if}
                </div>
                <div class="col-4">
                    {#if typeof pagination['next'] != "undefined"}
                        <button class="post-button-nav" on:click={handleClickPostNav(pagination['next'])}>Siguiente
                        </button>
                    {/if}
                </div>
            </div>
        {/if}
    </div>
</div>
<style>

    .text-dark{
        font-weight: bold;
    }

    .card-text{
        font-size: 17px;
    }

    .giveMeEllipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4; /* number of lines to show */
    }

    .pseudo-link {
        color: rgb(0,100,200);
        cursor: pointer;
    }

    .pseudo-link:hover {
        text-decoration: underline;
    }

    .post-button-nav {
        font-size: 19px;
        font-weight: 700;
        margin-top: 20px;
        margin-bottom: 30px;
        background-color: #93C126;
        border: 2px solid white;
        border-radius: 10px;
        color: white;
    }

    .white-bg {
        background-color: white;
        overflow: hidden;
    }

    .background-right {
        right: 0;
        position: absolute;
        height: 100%;
        /* max-height: 100vh; */
    }

    @media (max-width: 1400px) {
        .disabe-img {
            display: none;
        }

        .padding-fix {
            padding: 0 15px;
        }
    }

    .background-right {
        right: 0;
        position: absolute;
        height: 100%;
        max-height: 100vh;
    }

    .padding-fix {
        padding: 0 8px;
    }

    @media (max-width: 1400px) {
        .disabe-img {
            display: none;
        }

        .padding-fix {
            padding: 0 15px;
        }
    }

    .white-bg {
        background-color: white;
        overflow: hidden;
    }

</style>
